<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Innstillinger - {{name}}</h4>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormSubmittable">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" @click="handleSubmit()" class="button primary">Lagre endringer</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormProcessing">
        <a href="javascript:;" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormLoading">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary" disabled>Lagre<span class="show-for-medium"> endringer</span></a>
      </div>
    </div>

    <TheLoader :active="$store.getters.isFormLoading"/>
    <div v-if="!$store.getters.isFormLoading" class="content-container flex-row">
      <section class="content large-padding fixed-width small scrollnav">
        <form @submit.prevent="handleSubmit">
          <fieldset>
            <div class="grid-x grid-padding-x">
              <TheTextInput containerClassName="cell large-6" label="Betalingsartid" v-model.trim="item.Betalingsartid" :disabled="true"/>
              <TheTextInput containerClassName="cell large-6" label="Betalingsartkode" name="Betalingsartkode" :disabled="edit" v-model.trim="item.Betalingsartkode" maxlength="10" required v-validate="'required|max:10'"/>
              <TheTextInput containerClassName="cell large-12" label="Beskrivelse" name="Beskrivelse" v-model.trim="item.Beskrivelse" maxlength="50" v-validate="'max:50'"/>

              <TheSwitchInput v-model="item.Passiv" labelTrue="Passiv" labelFalse="Ikke passiv" trueValue="T" falseValue="F"/>
            </div>
          </fieldset>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import InstillingerService from '@/services/InstillingerService'

export default {
  name: 'InstillingerBetalingsartEdit',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    servicename: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      service: InstillingerService(this.servicename),
      edit: false,
      item: {},
      loading: true
    }
  },
  created () {
    // Set form to loading
    this.setFormLoading(true)

    // Edit mode
    this.edit = !!this.$route.params.id

    // Load
    this.fetch()
  },
  methods: {
    fetch: function () {
      if (!this.edit) {
        this.item.Passive = 'F'

        this.setFormLoading(false)
      } else {
        this.service.view(this.$route.params.id)
          .then((response) => {
            this.item = response.data
          })
          .catch(() => {
            this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn betalingsart')

            this.onCancel()
          })
          .then(() => {
            this.setFormLoading(false)
          })
      }
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            // Force code to be uppercase
            this.item.Betalingsartkode = this._.toUpper(this.item.Betalingsartkode)

            this.service.save(this.item.Betalingsartid, this.item)
              .then((response) => {
                this.$helpers.showSuccessAlert('Betalingsart er lagret')

                this.item = response.data

                if (!this.edit) {
                  this.$router.go(-1)
                }
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                } else {
                  this.$helpers.showErrorAlert('Feil', 'Noe gikk galt, prøv igjen', 'danger')
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    onCancel: function () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
input[name="Betalingsartkode"] {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/InstillingerBetalingsartEdit.vue